__turbopack_context__.v({
  "textContainer": "styles-module-scss-module__ztLP0W__textContainer",
});
